import React, { memo } from "react";
import Master from "./";
import PT from "prop-types";
import FreeSlotsModal from "_c/Modals/free-slots";
import { useFreeSlotsModalState } from "./hooks";

const MastersList = memo((props) => {
  const {
    state: freeSlotsState,
    open: openFreeSlots,
    close: closeFreeSlots,
  } = useFreeSlotsModalState();
  return (
    <>
      {props.masters.map((master) => (
        <Master
          hl={props.hl}
          t={props.t}
          openMapPopup={props.openMapPopup}
          key={master._id}
          master={master}
          openFreeSlots={openFreeSlots}
        />
      ))}
      <FreeSlotsModal
        onClose={closeFreeSlots}
        t={props.t}
        isOpen={freeSlotsState.isOpen}
        masterId={freeSlotsState.masterId}
      />
    </>
  );
});
MastersList.propTypes = {
  masters: PT.array,
  hl: PT.string,

  openMapPopup: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default MastersList;
